module.exports = __webpack_public_path__ + "img/home-visual-02_m.e8aa3001.png";